import FingerprintIcon from "@mui/icons-material/Fingerprint";
import BoltIcon from "@mui/icons-material/Bolt";
import BedtimeOutlinedIcon from "@mui/icons-material/BedtimeOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { Card, Divider } from "@mui/joy";
import { useEffect } from "react";
import { Bug, Terminal } from "lucide-react";
import PeopleIcon from '@mui/icons-material/People';
import WorkIcon from '@mui/icons-material/Work';
import BugReportIcon from '@mui/icons-material/BugReport';

const features = [
  {
    icon: Terminal,
    title: "CTF Challenges",
    description:
      "Engage in realistic capture-the-flag scenarios designed to test and improve your cybersecurity skills across multiple domains.",
    bgColor: "bg-blue-50",
    iconColor: "text-blue-500",
  },
  {
    icon: BugReportIcon,
    title: "Bug Bounty Programs",
    description:
      "Join live bug bounty programs to identify vulnerabilities in real-world applications and earn rewards for your findings.",
    bgColor: "bg-yellow-50",
    iconColor: "text-yellow-500",
  },
  {
    icon: PeopleIcon,
    title: "Community Collaboration",
    description:
      "Join a vibrant community of cybersecurity enthusiasts to share ideas, solve challenges together, and grow your expertise.",
    bgColor: "bg-purple-50",
    iconColor: "text-purple-500",
  },
  {
    icon: WorkIcon,
    title: "Recruitment Platform",
    description:
      "Connect with recruiters through our talent hunt platform. Showcase your skills in CTFs and challenges to secure opportunities with top organizations.",
    bgColor: "bg-indigo-50",
    iconColor: "text-indigo-500",
  },
];

export default function FeaturesSection({ dark }: { dark: boolean }) {
  useEffect(() => {}, [dark]);
  return (
    <section
      id="features"
      className="w-full py-12 md:py-24 lg:py-24 hide-scrollbar "
      style={{ backgroundColor: dark ? "" : "#f9fafb" }}
    >
      <div className="container px-4 md:px-6 mx-auto space-y-6">
        <h2
          className="text-3xl font-bold tracking-tighter sm:text-4xl md:text-5xl text-center mb-20 "
          style={{ color: dark ? "#38BDF8" : "#7B3FE4" }}
        >
          Platform Features
        </h2>
        <div className="overflow-x-auto pb-6">
          <div className="flex flex-wrap gap-6 justify-center xl:justify-start">
            {features.map((feature, index) => (
              <Card
                className="rounded-xl shadow-xl overflow-hidden flex-shrink-0 w-[350px]"
                key={index}
                sx={{
                  backgroundColor: dark ? "#1f2937" : "bg-white",
                }}
              >
                <div className="p-6 flex flex-col items-center">
                  <div
                    className={`${feature.bgColor} w-16 h-16 rounded-full flex items-center justify-center mb-4`}
                  >
                    <feature.icon className={`${feature.iconColor} w-6 h-6`} />
                  </div>
                  <h3 className="text-lg font-semibold mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-center">
                    {feature.description}
                  </p>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
